import React from 'react';
import { Typography, Paper, Grid, Avatar } from '@mui/material';
import { AddonInterface } from '../../../store/sellingCakeReport/api/interface';
import { getAssetURl } from '../../../utils/url';
import { isValidArray } from '../../../utils/valid';
import { useAppSelector } from '../../../store';

interface IProps {
  topSellingAddon: AddonInterface[] | undefined;
  lessSellingAddon: AddonInterface[] | undefined;
}

const Addons: React.FC<IProps> = ({ topSellingAddon, lessSellingAddon }) => {
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  return (
    <Paper
      elevation={3}
      sx={{ padding: 2, height: '100%' }}
    >
      <Typography
        variant='h6'
        gutterBottom
      >
        Add-ons
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Most Sold</Typography>
        </Grid>
        {!isValidArray(topSellingAddon) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {topSellingAddon?.map((addon) => (
          <Grid
            item
            xs={6}
            key={addon?.labelEn}
          >
            <Avatar
              alt={addon?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(addon?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {addon?.labelEn} (Sold:{addon?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Least Sold</Typography>
        </Grid>
        {!isValidArray(lessSellingAddon) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {lessSellingAddon?.map((addon) => (
          <Grid
            item
            xs={6}
            key={addon?.labelEn}
          >
            <Avatar
              alt={addon?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(addon?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {addon?.labelEn} (Sold:{addon?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default Addons;
